// Copyright (c) 2019 Deere & Company
import { createErrorMessage } from '../action-creator/alert-messages';
import store from '../../../store';

export const customizeErrorAlert = errMessage => {

    const { dispatch } = store;
    dispatch( createErrorMessage( errMessage ) );

};
